var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "#251D97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22217 1.22223V9.77778H9.77772V1.22223H1.22217ZM8.82803 8.82809H2.17216V2.17222H8.82803V8.82809Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93665 3.06329H3.06323V7.93671H7.93665V3.06329ZM6.99169 6.99205H4.0079V4.00826H6.99169V6.99205Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareDots);
export default __webpack_public_path__ + "static/media/squareDots.e3a2a37ab524e22ac5f5a6da5045d5a1.svg";
export { ForwardRef as ReactComponent };